import { getDocument } from "../apis/firebase"
import { get, set } from "idb-keyval"

export const getMetadata = async (language, version) =>
  getDocument(`sourceMetadata/${language}-${version}`)
    .then(response => {
      if (!response.data() || response.data() === null) {
        get(`${language}-${version}-metadata`).then(val => val)
      } else {
        set(`${language}-${version}-metadata`, response.data())
        return response.data()
      }
    })
    .catch(async err => {
      console.log("getMetadata ERROR:", err)
      const retrievedMetadata = await get(
        `${language}-${version}-metadata`
      ).then(val => val)
      return retrievedMetadata
    })
